export const LOADING = 'LOADING'
export const LOADING_FINISHED = 'LOADING_FINISHED'
export const LOADING_ERROR = 'LOADING_ERROR'

export interface ILoaderState {
  type: typeof LOADING | typeof LOADING_FINISHED | typeof LOADING_ERROR
  customMessage?: string
}
